export enum MigrationStatusType {
  STARTED = 'STARTED',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  ACTIVATED = 'ACTIVATED',
  NO_AVAILABILITY = 'NO_AVAILABILITY',
}



// WEBPACK FOOTER //
// ./src/app/merchants/settings/migration-status-type.ts